import { useState, useEffect } from 'react';
import { apiService } from '../services/api';

interface ContactInfo {
  title: string;
  description: string;
  icon: 'location' | 'phone' | 'calendar' | 'whatsapp';
  extraDescription?: string;
}

interface Button {
  text: string;
  url: string;
  variant: 'primary' | 'secondary' | 'tertiary' | 'outline';
}

interface ContactSectionData {
  title: string;
  subtitle: string;
  appointmentText: string;
  addressSection?: ContactInfo;
  phoneSection?: ContactInfo;
  whatsappSection?: ContactInfo;
  appointmentButton?: Button;
}

interface UseContactSectionReturn {
  data: ContactSectionData | null;
  loading: boolean;
  error: string | null;
}

export function useContactSection(): UseContactSectionReturn {
  const [data, setData] = useState<ContactSectionData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchContactSection = async () => {
      try {
        setLoading(true);
        setError(null);

        // Use centralized service with shape normalization
        const result: any = await apiService.getContactSection();

        const attributes = result?.attributes ? result.attributes : result;

        if (attributes) {
          setData({
            title: attributes.title || 'Contact',
            subtitle: attributes.subtitle || '',
            appointmentText: attributes.appointmentText || '',
            addressSection: attributes.addressSection,
            phoneSection: attributes.phoneSection,
            whatsappSection: attributes.whatsappSection,
            appointmentButton: attributes.appointmentButton,
          });
        }
      } catch (err) {
        console.log('Contact section API not available yet, using fallback data');
        // Don't set error, just use fallback data
        setError(null);
      } finally {
        setLoading(false);
      }
    };

    fetchContactSection();
  }, []);

  return { data, loading, error };
} 